import { SpecialFont } from '@/types';
import { fetchFromDesignerService } from './fetchFromDesignerService';

export const fetchSpecialFonts = () => {
  const abortController = new AbortController();
  setTimeout(() => abortController.abort(), 2000);
  return fetchFromDesignerService<{ data: SpecialFont[] }>(
    'fonts',
    {},
    { signal: abortController.signal }
  )
    .then(({ data }) => data)
    .catch(() => [] as SpecialFont[]);
};
